import { useGetFuels } from '@shared/api/hooks/ccf/fuels';
import { useGetActivityTypeUnits } from '@shared/api/hooks/ccf/units';
import { RepeatableFormRows } from '@shared/components/form/repeatable-form-rows';
import SelectFormField from '@shared/components/form/select-form-field';
import SelectSearchFormField from '@shared/components/form/select-search-form-field';
import { useFormContext } from 'react-hook-form';
import { useFormattedFuels, useUnitOptions } from '../../../../utils';
import BusinessTravelRecordsRow from '../business-travel-records-row';

interface FuelUsageFieldsProps {
  isEditMode: boolean;
}

export default function FuelUsageFields({ isEditMode }: FuelUsageFieldsProps) {
  const { watch } = useFormContext();
  const site = watch('site');
  const fuel = watch('fuel');

  const { data: fuels, isLoading: isFuelsLoading } = useGetFuels({
    site,
    include_travel: true,
  });

  const { data: units, isLoading: isUnitsLoading } = useGetActivityTypeUnits(
    'business-travel',
    { site, fuel },
    { enabled: !!fuel || isEditMode }
  );

  const formattedFuels = useFormattedFuels(fuels!);
  const formattedUnits = useUnitOptions(units!);

  const noFuelsAvailable = !isFuelsLoading && fuels?.length === 0;
  const noFuelSelected = !noFuelsAvailable && !fuel;

  return (
    <>
      <div className="grid grid-cols-12 gap-2">
        <SelectSearchFormField
          name="fuel"
          pluralName="fuels"
          label="Fuel"
          options={formattedFuels}
          disabled={isEditMode || isFuelsLoading || noFuelsAvailable}
          placeholder={noFuelsAvailable ? 'No fuels available' : ''}
          className="col-span-6"
        />
        {!isEditMode && (
          <SelectFormField
            name="unit"
            label="Unit"
            options={formattedUnits}
            loading={!!fuel && isUnitsLoading}
            disabled={
              noFuelsAvailable || noFuelSelected || isUnitsLoading || !units
            }
            placeholder={
              noFuelsAvailable || noFuelSelected ? 'Select a fuel first' : ''
            }
            className="col-span-6"
          />
        )}
      </div>
      <RepeatableFormRows
        name="records"
        includeErrorMessage
        showAddButton={false}
        component={BusinessTravelRecordsRow}
        newRowObject={{ uuid: '', quantity: undefined, timePeriod: '' }}
      />
    </>
  );
}
